import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { mediaMaxWidth } from '../../utils/styles'

const SocialNavTitle = styled.h4`
  margin: 0;
  font-weight: ${theme('fontWeights.regular')};

  @media (max-width: ${mediaMaxWidth('large')}) {
    width: 100%;
  }
`

export default SocialNavTitle
